import Vue from 'vue';
import Router from 'vue-router';

import HomePage from "@/components/HomePage";
import ProductinformationPage from "@/components/ProductinformationPage";
import KnowledgeSharingPage from "@/components/KnowledgeSharingPage";
import ErgoletPage from "@/components/ErgoletPage";
import ProfileingPage from "@/components/ProfileingPage";
import NewsPage from "@/components/NewsPage";
import AboutPage from "@/components/AboutPage";
import QAndAPage from "@/components/QAndAPage";
import ContactPage from "@/components/ContactPage";
import VendletPage from "@/components/VendletPage";


Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {path: '/', component: HomePage},
        {path: '/produktinformation', component: ProductinformationPage},
        {path: '/intern-vidensdeling', component: KnowledgeSharingPage},
        {path: '/ergolet', component: ErgoletPage},
        {path: '/vendlet', component: VendletPage},
        {path: '/profilering', component: ProfileingPage},
        {path: '/nyheder', component: NewsPage},
        {path: '/om', component: AboutPage},
        {path: '/q-og-a', component: QAndAPage},
        {path: '/kontakt', component: ContactPage},
        {path: '*', redirect: '/'},
    ],
})